import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CoreConfigService } from '@core/services/config.service';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { AuthenticationService } from 'app/auth/service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {
  //  Public
  public coreConfig: any;
  public submitted = false;
  public error = null;
  public message = null;

  public form: FormGroup = new FormGroup({
    email: new FormControl(null, [Validators.required, Validators.email])
  });

  // Private
  private _unsubscribeAll: Subject<any>;
  constructor(
    private _coreConfigService: CoreConfigService,
    private _authenticationService: AuthenticationService
    ) { 
      this._unsubscribeAll = new Subject();
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  ngOnInit(): void {
    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  /**
   * On Submit
   */
  onSubmit() {
    this.message = null;
    this.error = null;
    this.submitted = true;

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    // Login
    this._authenticationService
      .forgotPassword(this.f.email.value)
      .pipe(first())
      .subscribe(
        data => {
          this.error = null;
          const { code, message } = data || {};
          if (code === 1001) {
            this.message = message;
            setTimeout(() => {
              this.message = null;
            }, 3000);
            this.submitted = false;
            this.form.reset();
          }
          else {
            this.error = message;
            setTimeout(() => {
              this.error = null;
            }, 3000);
          }
        },
        error => {
          this.error = error;
          setTimeout(() => {
            this.error = null;
          }, 3000);
        }
      );
  }

}
